// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__hrMk9","productName":"Table_productName__18PE5"};